// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__2ySbl","activeHandle":"RangeSlider_activeHandle__q34mp"};